import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, BasicQueryCheckbox } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content } from 'core/layouts';

function PersonListTemplate({ listViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization,
        inactiveCheckboxStore,
        oninactiveChange
    } = listViewStore;
    
    return (
        <ApplicationListLayout store={listViewStore}>
            <Content  emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} >
                    <div className="col u-flex--self--center form__group">
                        <label className="form__group__label">Select Persons to show</label>
                        <BasicQueryCheckbox 
                            id='inactive' 
                            queryUtility={queryUtility} 
                            propertyName='inactive' 
                            label='Show Inactive' 
                            store={inactiveCheckboxStore} 
                            onChange={oninactiveChange} 
                        />
                    </div>
                    </TableFilter>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='PERSON.LIST.EMPTY_STATE.TITLE' description='PERSON.LIST.EMPTY_STATE.DESCRIPTION' />
}

PersonListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

export default defaultTemplate(PersonListTemplate);
